import React from 'react';
import Styles from './carrouselActus.module.scss';
import { Carousel, CarouselItem, CarouselIndicators, CarouselControl } from 'reactstrap';
import ActualitesService from "../../services/actualitesService";
import IActualite from 'model/actualite';
import CarrouselItem from './carrouselItem';

interface ICarrouselActusState {
  actus: IActualite[],
  currentIndex: number
}

interface ICarrouselActusProps {

}

class CarrouselActus extends React.Component<ICarrouselActusProps, ICarrouselActusState>
{
  private animating: boolean;
  /**
   *
   */
  constructor(props: ICarrouselActusProps) {
    super(props);

    this.state = { actus: [], currentIndex: 0 };

    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
    this.animating = false;
  }
  componentDidMount() {
    ActualitesService.GetActusALaUne().then(actus => {
      this.setState({ actus: actus });
    })
  }

  render() {
    let slides = this.state.actus.map(a => <CarouselItem key={a.Id}><CarrouselItem actu={a} /></CarouselItem>);
    return (
      <div className={Styles.CarrouselActus}>
        <Carousel
          activeIndex={this.state.currentIndex}
          next={this.next}
          previous={this.previous}
          pause={'hover'}
        >
          <CarouselIndicators items={this.state.actus} activeIndex={this.state.currentIndex} onClickHandler={this.goToIndex} />
          {slides}
          <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
          <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
        </Carousel>
      </div>
    );
  }



  onExiting() {
    this.animating = true;
  }

  onExited() {
    this.animating = false;
  }

  next() {
    if (this.animating) return;
    const nextIndex = this.state.currentIndex === this.state.actus.length - 1 ? 0 : this.state.currentIndex + 1;
    this.setState({ currentIndex: nextIndex });
  }

  previous() {
    if (this.animating) return;
    const nextIndex = this.state.currentIndex === 0 ? this.state.actus.length - 1 : this.state.currentIndex - 1;
    this.setState({ currentIndex: nextIndex });
  }

  goToIndex(newIndex: number) {
    if (this.animating) return;
    this.setState({ currentIndex: newIndex });
  }


}

export default CarrouselActus;
